import type { OperationModel } from "~/core/models/OperationModel.interface";
import { checkIsOperationModelEnabled } from "~/core/utils/checkIsOperationModelEnabled";

/**
 * Check if any operation model is enabled in the current license.
 *
 * @param {OperationModel[]} operationsModels List of operation models to check.
 * @returns {boolean} True if at least one operation model is enabled, false otherwise.
 */
export const hasOperationModelEnabledInLicense = (
  operationsModels: OperationModel[],
): boolean => {
  return operationsModels.some((operationModel: OperationModel) =>
    checkIsOperationModelEnabled(operationModel),
  );
};
